import * as React from 'react';

import classnames from 'classnames';

import {Card} from 'shells/card/card';
import {HelpButton} from 'shells/help/help-button';
import {PopoverInfo} from 'shells/popover-info/popover-info';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {FormFragment as Form} from 'nutshell-graphql-types';

import {FormEngagementMetricModal} from '../../../email-marketing/tooltip-modals/form-engagement-metric-modal';
import type {ReportURLParams} from '../../../reports/report-types';

import {FormEngagementBar} from './form-engagement-bar';
import {FormEngagementReport} from './form-engagement-report';
import {FormLocationsTableContainer} from './form-locations-table-container';

import styles from './form-engagement.module.css';

type Props = {
    form: Form;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
};

export function FormEngagement(props: Props) {
    const {form, onParamChange, onParamPush, urlParams} = props;
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

    return (
        <div>
            <SpacerGroup mb={32}>
                <div className={classnames('mb-8', styles['locations-container'])}>
                    <UppercaseLabel>Engagement</UppercaseLabel>
                    <HelpButton
                        // @ts-expect-error
                        size={18} // {sizeValue}
                        onClick={() => {
                            setIsModalOpen(true);
                        }}
                    />
                </div>
                <Card hasBorder={true} hasShadow={true}>
                    <div className='flex'>
                        <div className='flex-shrink'>
                            <FormEngagementBar
                                pageVisits={form.pageVisits}
                                numSubmissions={form.numSubmissions}
                                conversionRate={form.conversionRate}
                            />
                        </div>
                        <FormEngagementReport
                            form={form}
                            onParamChange={onParamChange}
                            onParamPush={onParamPush}
                            urlParams={urlParams}
                        />
                    </div>
                </Card>
            </SpacerGroup>
            <div>
                <div className={styles['locations-container']}>
                    <UppercaseLabel>Form locations</UppercaseLabel>
                    <PopoverInfo
                        size={18}
                        bodyColor='dark'
                        info='Ths URLs of all the webpages where this form has been embedded'
                    />
                </div>
                <FormLocationsTableContainer formId={form.id} showStats={true} />
            </div>
            <FormEngagementMetricModal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                }}
            />
        </div>
    );
}
